import { createSelector, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { DismissCountBanners } from '@/constants/closedBanners';
import { RootState } from '../store';

export interface IDashboardSessionState {
  // Session-only hide for dismissable promo banners. Persisted via storageSession
  // so it survives intra-tab navigation but resets when the tab closes (BFS #10).
  bannerSessionHidden: Partial<Record<DismissCountBanners, boolean>>;
}

const initialState: IDashboardSessionState = {
  bannerSessionHidden: {},
};

const dashboardSessionSlice = createSlice({
  name: 'dashboardSession',
  initialState,
  reducers: {
    hideBannerForSession: (state, action: PayloadAction<DismissCountBanners>) => {
      state.bannerSessionHidden[action.payload] = true;
    },
    resetSession: () => initialState,
  },
});

export const makeBannerSessionHiddenSelector = (key: DismissCountBanners) =>
  createSelector(
    (state: RootState) => state.dashboardSession.bannerSessionHidden,
    (m) => m[key] ?? false,
  );

export default dashboardSessionSlice;
